// src/components/sports/SportsSidebar.jsx
import React from 'react';

const SportsSidebar = ({ selectedSport, onSportSelect }) => {
  const sports = [
    { id: 'football', name: 'Football', icon: '⚽', matches: 247 },
    { id: 'basketball', name: 'Basketball', icon: '🏀', matches: 128 },
    { id: 'tennis', name: 'Tennis', icon: '🎾', matches: 64 },
    { id: 'baseball', name: 'Baseball', icon: '⚾', matches: 42 },
    { id: 'hockey', name: 'Ice Hockey', icon: '🏒', matches: 36 },
    { id: 'esports', name: 'Esports', icon: '🎮', matches: 89 },
    { id: 'cricket', name: 'Cricket', icon: '🏏', matches: 23 },
    { id: 'rugby', name: 'Rugby', icon: '🏉', matches: 18 },
  ];

  return (
    <div className="bg-gray-900 rounded-xl p-4">
      <h3 className="text-lg font-bold text-white mb-4">Sports Categories</h3>
      <div className="space-y-2">
        {sports.map(sport => (
          <button
            key={sport.id}
            onClick={() => onSportSelect(sport.id)}
            className={`w-full flex items-center justify-between p-3 rounded-lg transition-colors ${
              selectedSport === sport.id
                ? 'bg-blue-600 text-white'
                : 'hover:bg-gray-800 text-gray-300'
            }`}
          >
            <div className="flex items-center">
              <span className="text-xl mr-3">{sport.icon}</span>
              <span className="text-sm sm:text-base">{sport.name}</span>
            </div>
            <span className="bg-gray-800 text-gray-400 text-xs px-2 py-1 rounded">
              {sport.matches}
            </span>
          </button>
        ))}
      </div>
      
      {/* Quick Filters */}
      <div className="mt-6 pt-6 border-t border-gray-800">
        <h4 className="text-sm font-bold text-white mb-3">Quick Filters</h4>
        <div className="space-y-2">
          <button className="w-full text-left p-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800 rounded">
            ⭐ Popular Matches
          </button>
          <button className="w-full text-left p-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800 rounded">
            🔥 Live Now
          </button>
          <button className="w-full text-left p-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800 rounded">
            💰 High Odds
          </button>
        </div>
      </div>
    </div>
  );
};

export default SportsSidebar;